export const SERVER_IS_NOT_READY_MESSAGE = 'Server is not ready - Please reload the website';
